var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stacks-on-stacks"},_vm._l((_vm.stacks),function(stack,i){return _c('portal-target',{key:("stack-" + stack + "-" + i),attrs:{"name":("stack-" + i)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }